var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";
import { Button } from "./Button";
var Modal = React.forwardRef(function (_a, ref) {
    var isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children, title = _a.title, description = _a.description, _b = _a.size, size = _b === void 0 ? "lg" : _b, _c = _a.showCloseButton, showCloseButton = _c === void 0 ? true : _c, className = _a.className, props = __rest(_a, ["isOpen", "onClose", "children", "title", "description", "size", "showCloseButton", "className"]);
    if (!isOpen)
        return null;
    var sizeClasses = {
        sm: "max-w-md",
        md: "max-w-lg",
        lg: "max-w-2xl",
        xl: "max-w-4xl",
        full: "max-w-6xl"
    };
    var handleBackdropClick = function (e) {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };
    React.useEffect(function () {
        var handleEscape = function (e) {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }
        return function () {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);
    return (_jsxs("div", __assign({ className: "fixed inset-0 z-50 flex items-center justify-center p-4", onClick: handleBackdropClick }, { children: [_jsx("div", { className: "absolute inset-0 bg-background/80 backdrop-blur-sm" }), _jsxs("div", __assign({ ref: ref, className: cn("relative bg-card text-card-foreground rounded-lg shadow-lg border", sizeClasses[size], "w-full max-h-[90vh] overflow-hidden animate-fade-in", className), onClick: function (e) { return e.stopPropagation(); } }, props, { children: [(title || description || showCloseButton) && (_jsxs("div", __assign({ className: "flex items-start justify-between p-6 border-b" }, { children: [_jsxs("div", __assign({ className: "space-y-1.5" }, { children: [title && (_jsx("h2", __assign({ className: "text-lg font-semibold leading-none tracking-tight" }, { children: title }))), description && (_jsx("p", __assign({ className: "text-sm text-muted-foreground" }, { children: description })))] })), showCloseButton && (_jsxs(Button, __assign({ variant: "ghost", size: "icon", onClick: onClose, className: "h-6 w-6 p-0" }, { children: [_jsx(X, { className: "h-4 w-4" }), _jsx("span", __assign({ className: "sr-only" }, { children: "Close" }))] })))] }))), _jsx("div", __assign({ className: "flex-1 overflow-y-auto custom-scrollbar" }, { children: children }))] }))] })));
});
Modal.displayName = "Modal";
export { Modal };
